'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _css = require('../lib/css');

var _traits = require('../lib/traits');

var defaultTraits = _interopRequireWildcard(_traits);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Higher order component to take a styles function and call it with the necessary props and traits
 */
var withStyles = function withStyles(styles) {
  var keyframes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (ComponentToWrap) {
    var ConnectStyles = function (_Component) {
      _inherits(ConnectStyles, _Component);

      function ConnectStyles() {
        _classCallCheck(this, ConnectStyles);

        return _possibleConstructorReturn(this, (ConnectStyles.__proto__ || Object.getPrototypeOf(ConnectStyles)).apply(this, arguments));
      }

      _createClass(ConnectStyles, [{
        key: 'render',
        value: function render() {
          // Get current traits and defaults from context
          var _context$traits = this.context.traits,
              traits = _context$traits === undefined ? defaultTraits : _context$traits;

          // Build our combined props from the component itself's default props,
          // The specified default traits, and the actual provided props

          var combinedProps = _extends({}, ComponentToWrap.defaultProps, this.props);

          // Add any keyframes
          var keyframesIsFunction = typeof keyframes === 'function';
          var keyframesObject = keyframesIsFunction ? keyframes(combinedProps, traits) : keyframes;
          var keyframeNames = (0, _css.addKeyframes)(keyframesObject);

          // Opt out of built-in styles
          if (_typeof(this.props.classNames) === 'object') {
            var _newProps = _extends({}, combinedProps, {
              styles: {},
              classNames: this.props.classNames
            });

            return _react2.default.createElement(ComponentToWrap, _newProps);
          }

          // If styles is a function, call it and pass through our props and traits
          var stylesIsFunction = typeof styles === 'function';
          var stylesObject = stylesIsFunction ? styles(combinedProps, traits, keyframeNames) : styles;

          // Build out our final props to be passed down to the original component
          var newProps = _extends({}, combinedProps, {
            styles: stylesObject,
            classNames: (0, _css.stylesToClasses)(stylesObject)
          });

          return _react2.default.createElement(ComponentToWrap, newProps);
        }
      }]);

      return ConnectStyles;
    }(_react.Component);

    ConnectStyles.contextTypes = {
      traits: _propTypes2.default.object
    };

    return ConnectStyles;
  };
};

exports.default = withStyles;


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/with-styles/index.js
// module id = 3
// module chunks = 0